function showContent(contentId) {
  const SpecContents = document.querySelectorAll(".spec-content");
  const buttons = document.querySelectorAll("#custom-navigation button");

  SpecContents.forEach((content) => {
    content.classList.remove("active");
  });

  buttons.forEach((button) => {
    button.classList.remove("active");
  });

  document.getElementById(contentId).classList.add("active");
  document
    .querySelector(`#custom-navigation button[onclick*="${contentId}"]`)
    .classList.add("active");
}

document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(".t4s-dib.t4s-swatch__current");

  if (elements.length > 0) {
    const values = [];

    elements.forEach((element) => {
      const value = element.textContent.trim();
      values.push(value);
    });

    const result = values.join(" / ");
    // console.log(result);

    updateFive(result);
  } else {
    console.log("Cannot find matched e");
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "childList" ||
        mutation.type === "characterData" ||
        mutation.type === "attributes"
      ) {
        const elements = document.querySelectorAll(
          ".t4s-dib.t4s-swatch__current"
        );

        if (elements.length > 0) {
          const values = [];

          elements.forEach((element) => {
            const value = element.textContent.trim();
            values.push(value);
          });

          const result = values.join(" / ");
          // console.log(result);

          updateFive(result);
        } else {
          console.log("Cannot find");
        }
      }
    });
  });

  const config = {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
  };
  const targetNode = document.querySelector(".t4s-swatch");

  if (targetNode) {
    observer.observe(targetNode, config);
  } else {
    console.log("Cannot find watch target e");
  }
});

function updateFive(result) {
  const couponContainers = document.querySelectorAll(
    ".specification-img"
  );

  couponContainers.forEach((container) => {
    container.style.display = "none";
  });

  const matchingContainer = document.querySelector(
    `.specification-img[data-variant-title="${result}"]`
  );
  if (matchingContainer) {
    matchingContainer.style.display = "block";
  } else {
    console.log("Cannot find specification-img container");
  }
}
